<template>
  <div class="app-right-main">
    <el-row :gutter="20" class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form
          :model="searchForm"
          size="mini"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label="">
            <el-input
              v-model="searchForm.keyword"
              clearable
              placeholder="请输入会员编号、用户名称、编号、手机号、邮箱"
              style="width: 360px"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员状态">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择"
              clearable
              style="width: 12vw"
            >
              <el-option
                v-for="(v, k) in statusMap"
                :key="k"
                :label="v"
                :value="k"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员内容">
            <el-select
              v-model="searchForm.classify"
              placeholder="请选择"
              clearable
              style="width: 12vw"
            >
              <el-option
                v-for="(v, k) in classifyMap"
                :key="k"
                :label="v"
                :value="k"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="激活日期">
            <el-date-picker
              clearable
              v-model="searchForm.active_time"
              type="daterange"
              :value-format="'yyyy-MM-dd'"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期">
            <el-date-picker
              clearable
              v-model="searchForm.expires_time"
              type="daterange"
              :value-format="'yyyy-MM-dd'"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>

      <!-- 提交按钮 -->
      <el-col :span="2" class="searchbuttons">
        <div>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="init()"
            >查询</el-button
          >
        </div>
        <div class="searchButton">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px" v-permission="'redeem_manage'">
      <el-col :span="12">
        <router-link to="/redeem">
          <el-button type="primary" size="small">兑换码管理</el-button>
        </router-link>
      </el-col>
      <el-col :span="12" style="text-align: right"> </el-col>
    </el-row>

    <el-table
      :data="tbList"
      size="small"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column align="left" prop="un" label="用户名称">
        <template slot-scope="scope">
          <div
            style="color: #165dff; cursor: pointer"
            @click="toUserInfo(scope)"
          >
            {{ scope.row.un }}
          </div>
          <!-- <router-link
            :to="{
              path: '/userDetail',
              query: {
                id: scope.row.uid,
                tabs: 'first',
              },
            }"
          >
            {{ scope.row.un }}
          </router-link> -->
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="vip_name"
        label="会员内容"
      ></el-table-column>
      <el-table-column align="left" prop="mb" label="手机号">
        <template slot-scope="scope">
          <div
            style="color: #165dff; cursor: pointer"
            @click="toUserInfo(scope)"
          >
            {{ scope.row.mb }}
          </div>
          <!-- <router-link
            :to="{
              path: '/userDetail',
              query: {
                id: scope.row.uid,
                tabs: 'first',
              },
            }"
          >
            {{ scope.row.mb }}
          </router-link> -->
        </template>
      </el-table-column>
      <el-table-column align="left" prop="email" label="邮箱">
        <template slot-scope="scope">
          <div
            style="color: #165dff; cursor: pointer"
            @click="toUserInfo(scope)"
          >
            {{ scope.row.email }}
          </div>
          <!-- <router-link
            :to="{
              path: '/userDetail',
              query: {
                id: scope.row.uid,
                tabs: 'first',
              },
            }"
          >
            {{ scope.row.email }}
          </router-link> -->
        </template>
      </el-table-column>

      <el-table-column
        align="left"
        prop="active_time"
        label="激活日期"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="expires"
        label="到期日期"
      ></el-table-column>
      <el-table-column align="left" prop="status" label="会员状态" width="120">
        <template slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
    </el-table>

    <div class="dial-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 20, 50, 100, 200, 300, 400]"
        :page-size="size"
        layout="->,sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { vipList } from "../../api/userApi";
import { handleResponse } from "../../utils/response";

export default {
  name: "VipCenter",
  data() {
    return {
      statusMap: {
        1: "未生效",
        2: "已生效",
        // 3: "已作废",去除2024-06-05
        4: "已过期",
      },
      classifyMap: {
        1: "普通健康会员",
        2: "黄金健康会员",
        3: "海外VIP会员",
      },
      searchForm: {
        keyword: "",
        classify: "",
        status: "",
        active_time: [],
        expires_time: [],
      },
      tbList: [],
      size: 10,
      page: 1,
      total: 0,
      loading: true,
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    toUserInfo(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.uid,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    init(page = 1) {
      this.page = page;
      this.loading = true;
      const { active_time, expires_time, ...q } = this.searchForm;
      vipList({
        ...q,
        active_time:
          active_time?.length > 0
            ? active_time
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
        expires_time:
          expires_time?.length > 0
            ? expires_time
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
        page,
        size: this.size,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            this.tbList = data.list;
            this.total = data.count;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.init(val);
    },
    reset() {
      this.searchForm = {
        keyword: "",
        classify: "",
        status: "",
        active_time: [],
        expires_time: [],
      };
      this.init();
    },
  },
};
</script>
<style scoped></style>
